const validateTypeAndSize = (file) => {
  let xls = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  let size = file.size / 1024 / 1024 < 20;
  return xls && size;
};

export default validateTypeAndSize;
